<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";
import html2canvas from "html2canvas";
import axios from "axios";

import SustainfinityTable from "../../../components/SustainfinityTable.vue";

import internalAnswers from "./internal-answers.vue";
import externalAnswers from "./external-answers.vue";
import materialityMatrix from "./materiality-matrix.vue";
import mixed from "./mixed.vue";
import wordCloud from "./WordCloud_su2.vue"

import d_internalAnswers from "./d_internal-answers.vue";
import d_externalAnswers from "./d_external-answers.vue";
import d_mixed from "./d_mixed.vue";
import d_materialityMatrix from "./d_materiality-matrix.vue";

import internal_others from "./internal-answers_others.vue";
import internal_managers from "./internal-answers_managers.vue";
import external_others from "./external-answers_others.vue";
import external_managers from "./external-answers_managers.vue";
import external_customers from "./external-answers_customers.vue";

import d_internal_others from "./d_internal-answers_others.vue";
import d_internal_managers from "./d_internal-answers_managers.vue";
import d_external_others from "./d_external-answers_others.vue";
import d_external_managers from "./d_external-answers_managers.vue";
import d_external_customers from "./d_external-answers_customers.vue";

export default {
  name: "Materiality Analysis Survey Results",
  components: {
    internalAnswers,
    externalAnswers,
    materialityMatrix,
    mixed,
    wordCloud,
    d_internalAnswers,
    d_externalAnswers,
    d_mixed,
    d_materialityMatrix,
    internal_others,
    internal_managers,
    external_others,
    external_managers,
    external_customers,
    d_internal_others,
    d_internal_managers,
    d_external_others,
    d_external_managers,
    d_external_customers,
    SustainfinityTable,
  },
  data() {
    return {
      textResultsSU2: [],
      textResultsFields: [
        {
          key: "firstname",
          label: i18n.t("su2Results.header.firstname"),
          width: 1,
        },
        {
          key: "surname",
          label: i18n.t("su2Results.header.surname"),
          width: 1,
        },
        {
          key: "email",
          label: "Email",
          width: 1,
        },
        {
          key: "role_name",
          label: i18n.t("su2Results.header.roleName"),
          width: 1,
        },
        {
          key: "text_answer",
          label: i18n.t("su2Results.header.textAnswer"),
          width: 1,
        },
        {
          key: "completed_on",
          label: i18n.t("su2Results.header.completedOn"),
          width: 1,
        },
      ],
      
      selectedPopupComponent: null,
      
      su2Surveys: [],
      selectedSurveyID: "",
      selectedSurveyName: "",
      loading: false,

      selectedTab: 'graph',

      missingChecks: null,
    };
  },

  computed: {
    dashboardItemsMap() {
      return [
        { component: d_internalAnswers, popup_component: internalAnswers, visible: true, text: 'internal', file_name: 'su2_internalanswers' },
        { component: d_externalAnswers, popup_component: externalAnswers, visible: true, text: 'external', file_name: 'su2_externalanswers' },
        { component: d_mixed, popup_component: mixed, visible: true, text: 'mixed', file_name: 'su2_int_ext_bar' },
        { component: d_internal_others, popup_component: internal_others, visible: true, text: 'internal_oth', file_name: 'su2_int_others' },
        { component: d_internal_managers, popup_component: internal_managers, visible: true, text: 'internal_mng', file_name: 'su2_int_managers' },
        { component: d_external_others, popup_component: external_others, visible: true, text: 'external_oth', file_name: 'su2_ext_others' },
        { component: d_external_managers, popup_component: external_managers, visible: true, text: 'external_supp', file_name: 'su2_ext_managers' },
        { component: d_external_customers, popup_component: external_customers, visible: true, text: 'external_cst', file_name: 'su2_ext_customers' },
        { component: d_materialityMatrix, popup_component: materialityMatrix, visible: true, text: 'materialityMatrix', file_name: 'su2_materialityMatrix' },
        { component: null, popup_component: wordCloud, visible: false, text: 'wordCloud', file_name: 'su2_wordcloud' },
      ];
    }
  },

  watch: {
    selectedSurveyID() {
      const foundSurvey = this.su2Surveys.find(
        (obj) => obj.su2_survey_id == this.selectedSurveyID
      );
      this.selectedSurveyName = foundSurvey.su2_survey_name;
      if (this.selectedSurveyID) {
        this.textsResults();
      }
    },

    texts(newVal) {
      if (newVal == true) {
        this.textsResults();
      }
    },

    selectedPopupComponent(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.$refs.graphPopup.openPopup();
      }
    }
  },

  mounted() {
    this.getMySurveys();
    this.getMissingGraphs();
    this.textsResults();
  },

  methods: {
    ...mapActions("results", [
      "getSU2SurveyResults",
      "uploadReportGraph",
    ]),
    ...mapActions("surveys", ["getSU2Surveys"]),
    ...mapActions("reports", ["getGraphImagesInfo"]),

    getMissingGraphs() {
      const params = {
        company_id: this.$user.company_id
      }

      this.getGraphImagesInfo(params)
        .then(res => {
          this.missingChecks = res.data.check_images_exist;
        })
    },

    getMySurveys() {
      this.su2Surveys = [];
      const params = {
        created_by: this.$user.user_id,
        company_id: this.$user.company_id,
        is_deleted: false,
      };

      this.loading = true;
      this.getSU2Surveys(params)
        .then((res) => {
          this.su2Surveys = res.data;
          this.openingSurvey(res.data);
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 150);
        })
    },

    textsResults() {
      this.textResultsSU2 = [];
      let params = {
        company_id: this.$user.company_id,
        su2_survey_id: this.selectedSurveyID,
        is_deleted: "false",
      };
      this.getSU2SurveyResults(params)
        .then((res) => {
          for (let idx = 0; idx < res.data.length; idx++) {
            const element = res.data[idx];
            this.textResultsSU2.push({
              idx: idx,
              ...element,
            });
          }
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
    },
    
    openingSurvey(surveys) {
      surveys = surveys.sort((a, b) => b.su2_survey_id - a.su2_survey_id);
      this.selectedSurveyID = surveys[0].su2_survey_id;
    },

    selectGraph(graph) {
      this.selectedPopupComponent = graph;
    },

    downloadExcel() {
      let params = {
        su2_survey_id: this.selectedSurveyID,
        company_id: this.$user.company_id,
        created_by: this.$user.user_id,
      };
      axios
        .post(`/api/su2result/getsu2surveyresults`, params, {
          responseType: "blob",
        })
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Materiality Analysis Report - ${new Date().toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: response.data,
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },

    convertCanvasToFile(canvas, filename) {
      return new Promise((resolve, reject) => {
        try {
          canvas.toBlob((blob) => {
            const file = new File([blob], filename, { type: "image/png" });
            resolve(file);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    sendToBackend(screenshotFile) {
      const formData = new FormData();
      formData.append("files", screenshotFile);
      formData.append("user_id", this.$user.user_id);
      formData.append("company_id", this.$user.company_id);
      formData.append("survey_id", this.selectedSurveyID);
      formData.append("language", localStorage.getItem('lang') || 'en');
      this.uploadReportGraph(formData)
        .then((response) => {
          this.$notify('success', response.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.$refs.graphPopup.startHideProcess();
        })
    },

    confirmGraph() {
      const containerElement = this.$refs.screenshotArea.$el;
      // The popup chart is rendered in the UI language, so a Turkish render is saved as the "_tr" graph.
      const language = localStorage.getItem('lang') || 'en';
      const fileName = String(this.selectedPopupComponent.file_name).concat(language === 'tr' ? '_tr' : '', '.png');
      html2canvas(containerElement)
        .then((canvas) => {
          this.convertCanvasToFile(canvas, fileName)
            .then((file) => {
              this.sendToBackend(file);
            })
        })
    },

    handleMyTabs(tab) {
      this.selectedTab = tab;
    },
    
    startLoading(timeout) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, timeout);
    },
  },
};
</script>

<template>
  <div class="p-3">
    <loading-spinner v-if="loading" :container="true" color="var(--sustainfinity-green)" />
    <div v-else>
      <div>
        <div class="flex-all-centered-row" style="justify-content: flex-start; padding-bottom: 1.5em;">
          <select class="sust-btn sust-btn-green" style="max-height: 35px; min-width: 6em; margin-right: 1em;"
            v-model="selectedSurveyID" @change="startLoading(200)"
          >
            <option v-for="survey in su2Surveys"
              :value="survey.su2_survey_id"
              :key="survey.su2_survey_id"
            >
              {{ survey.su2_survey_name }}
            </option>
          </select>
          <button class="sust-btn sust-btn-blue flex-all-centered-row" 
            style="max-height: 35px; width: fit-content;"
            @click="downloadExcel()">
            {{ $t("su1Results.createExcel") }}
            <i class="fa-solid fa-file-excel" style="margin-left: 1em;"></i>
          </button>
        </div>

        <div class="tab-rounded">
          <div class="tab-btn" :class="{ 'active': selectedTab === 'graph' }" @click="handleMyTabs('graph')">
            {{ $t('su1Results.graphResults') }}
          </div>
          <div class="tab-btn" :class="{ 'active': selectedTab === 'text' }" @click="handleMyTabs('text')">
            {{ $t('su1Results.textResults') }}
          </div>
        </div>

        <div v-if="selectedTab === 'graph'" class="charts-container">
          <div
            v-for="(item, idx) in dashboardItemsMap" :key="idx"
            class="chart-box"
            @click="selectGraph(item)"
          >
            <div class="content">
              <h1>
                {{ $t(`su2Results.resultsPage.page.${item.text}.title`) }}
              </h1>
              <p>
                {{ $t(`su2Results.resultsPage.page.${item.text}.description`) }}
              </p>
            </div>
            <component v-if="item.visible" :is="item.component" :selectedSurveyID="selectedSurveyID" 
              :style="{'scale': item.text === 'materialityMatrix' ? .8 : 1}"
            />
            <div v-else class="flex-all-centered-row">
              <img src="/images/foul.png" alt="Wordcloud">
            </div>
          </div>
        </div>

        <div v-else-if="selectedTab === 'text'">
          <sustainfinity-table 
            :headers="textResultsFields"
            :items="textResultsSU2"
            :iterator="'idx'"
          />
        </div>

        <sust-popup
          ref="graphPopup"
          :title="selectedPopupComponent ? $t(`su2Results.resultsPage.page.${selectedPopupComponent.text}.title`) : ''"
          size="xl"
          :footer="false"
          @onHide="selectGraph(null)"
        >
          <div class="flex-all-centered-col">
            <div class="flex-all-centered-row" style="justify-content: flex-end;">
              <button class="sust-btn sust-btn-blue"
                @click="confirmGraph()"
              >
                Confirm Graph
              </button>
            </div>
            <component
              style="width: 75%;"
              v-if="selectedPopupComponent" 
              :is="selectedPopupComponent.popup_component" 
              :selectedSurveyID="selectedSurveyID"
              ref="screenshotArea"
              :class="{'background-image': selectedPopupComponent && selectedPopupComponent.text !== 'materialityMatrix'}"
            />
          </div>
        </sust-popup>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tab-rounded {
  border-radius: 200px;
  overflow: hidden;
  border: thin solid var(--sustainfinity-navy);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  margin-bottom: 1em;
}

.tab-btn {
  background-color: whitesmoke;
  color: var(--sustainfinity-navy);
  width: 100%;
  text-align: center;
  padding: .25em;

  transition: all 150ms;
  cursor: pointer;
}

.tab-btn:hover {
  background-color: lightgray;
}

.tab-btn.active {
  background-color: var(--sustainfinity-navy);
  color: whitesmoke;
  pointer-events: none;
}

.charts-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  align-content: flex-start;

  > .chart-box {
    background-color: var(--sustainfinity-navy) !important;
    border-radius: 1em;
    box-shadow: 0 .25em .5em .1em gray;
    width: 32%;
    margin-bottom: 2em;
    padding: 2em;
    cursor: pointer;

    transition: background-color 150ms, scale 250ms;

    &:hover {
      background-color: var(--sustainfinity-navy--hover);
      scale: 1.03;
    }
    
    > .content {
      text-align: center;
      color: whitesmoke !important;

      > h1 {
        font-size: 1.5rem;
      }
      
      > p {
        font-size: 1.05rem;
      }
    }
  }
}

.save-graph-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: .5em;

  max-width: fit-content;
  max-height: fit-content;

  z-index: 99;
}

.background-image::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/images/sustainfinity_512x512.png");
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: -1
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

img {
  width: 50%;
  vertical-align: middle;
}
</style>
